export const schemaForCustomerForm = (form) => (
    form?.is_referral ? form.json_schema : (form?.translated_json_schema || form?.json_schema)
);